export default "__VITE_ASSET__CZIIFIkH__"